import { apiFetch } from '@ami/react/core';
import { DealerBranchFilter } from './dealerBranchFilter';

const _baseEndPoint = 'dealer-branches';

export class DealerBranchSummary {
  constructor(json) {
    this.id = json.dealerBranchId;
    this.label = json.dealerBranchName;
    this.dealerBranchId = json.dealerBranchId;
    this.dealerGroupId = json.dealerGroupId;
    this.dealerBranchName = json.dealerBranchName;
    this.dealerGroupName = json.dealerGroupName;
    this.priceZoneId = json.priceZoneId;
    this.priceZoneName = json.priceZoneName;
    this.discountPercentage = json.discountPercentage;
    this.taxRate = json.taxRate;
    this.supportsInstallation = json.supportsInstallation;
    this.preferredMakes = json.preferredMakes;
    this.isRetired = json.isRetired;
    this.isExpeditedShippingEnabled = json.isExpeditedShippingEnabled;
    this.isRestockingFeeEnabled = json.isRestockingFeeEnabled;
    this.isFreightSurchargeEnabled = json.isFreightSurchargeEnabled;
    this.msrpMarkupPercentage = json.msrpMarkupPercentage;
    this.minimumProductsValue = json.minimumProductsValue;
    this.freightSurchargeAmount = json.freightSurchargeAmount;
    this.territoryManager = json.territoryManager;
    this.isoCurrencySymbol = json.isoCurrencySymbol;
    this.isEmailCommunicationEnabled = json.isEmailCommunicationEnabled;
    this.priceZoneSurcharge = json.priceZoneSurcharge;
    this.salesTeamId = json.salesTeamId;
    this.salesTeamName = json.salesTeamName;
    this.defaultDealerContactIds = json.defaultDealerContactIds || [];
    this.isAmiDealerBranch = json.isAmiDealerBranch;
    this.dealerBranchAddress = json.dealerBranchAddress;
  }
}

export class DealerBranch {
  constructor(item) {
    if (item) {
      this.id = item.id;
      this.name = item.name;
      this.shippingNotificationEmail = item.shippingNotificationEmail;
      this.dealerGroupId = item.dealerGroupId;
      this.dealerGroupName = item.dealerGroupName;
      this.salesTeamId = item.salesTeamId;
      this.salesTeams = item.salesTeams;
      this.priceZoneId = item.priceZoneId;
      this.taxProfileId = item.taxProfileId;
      this.chargeSalesTax = item.chargeSalesTax;
      this.location = item.location;
      this.carriers = item.carriers;
      this.preferredMakes = item.preferredMakes;
      this.excludedProductOptionBrandIds = item.excludedProductOptionBrandIds;
      this.excludedProductOptionTags = item.excludedProductOptionTags;
      this.defaultAMISalesPersonId = item.defaultAMISalesPersonId;
      this.defaultTerritoryManagerId = item.defaultTerritoryManagerId;
      this.e2CustomerNumber = item.e2CustomerNumber;
      this.defaultSalesPersonName = item.defaultSalesPersonName;
      this.defaultTerritoryManagerName = item.defaultTerritoryManagerName;
      this.defaultDealerContactIds = item.defaultDealerContactIds || [];
      this.discountPercentageOverride = item.discountPercentageOverride;
      this.disableAdditionalDiscounts = item.disableAdditionalDiscounts;
      this.dealerBranchAddress = item.dealerBranchAddress;
      return;
    }
    this.id = null;
    this.name = '';
    this.shippingNotificationEmail = '';
    this.dealerGroupId = '';
    this.dealerGroupName = '';
    this.salesTeamId = '';
    this.priceZoneId = '';
    this.taxProfileId = '';
    this.chargeSalesTax = false;
    this.location = undefined;
    this.carriers = [];
    this.preferredMakes = [];
    this.excludedProductOptionBrandIds = [];
    this.excludedProductOptionTags = [];
    this.defaultAMISalesPersonId = '';
    this.defaultTerritoryManagerId = '';
    this.e2CustomerNumber = '';
    this.defaultDealerContactIds = [];
    this.discountPercentageOverride = null;
    this.disableAdditionalDiscounts = false;
    this.dealerBranchAddress = '';
  }

  static async search(filter = new DealerBranchFilter(), page) {
    const newFilter = new DealerBranchFilter(filter);
    if (newFilter.name) {
      newFilter.name = encodeURIComponent(newFilter.name);
    }

    newFilter.setPaginationParameters(page);
    const result = await apiFetch(`${_baseEndPoint}?${newFilter.toQueryString()}`);
    return result.map((x) => new DealerBranchSummary(x));
  }

  static async getById(id) {
    const entity = await apiFetch(`${_baseEndPoint}/${id}`);
    return new DealerBranch(entity);
  }

  static ByPriceZoneId(priceZoneId) {
    return apiFetch(`${_baseEndPoint}?priceZoneId=${priceZoneId}`).then(
      (entities) =>
        Promise.resolve(entities.map((x) => new DealerBranchSummary(x)))
    );
  }

  static bulkUpdateDownloadTemplate() {
    return apiFetch(`${_baseEndPoint}/bulk-update/template`, 'GET', null, {
      contentType: 'text/csv',
    });
  }

  static downloadCsv() {
    return apiFetch(`${_baseEndPoint}/csv`, 'GET', null, {
      contentType: 'text/csv',
    });
  }

  static retire(id) {
    return apiFetch(`${_baseEndPoint}/${id}`, 'DELETE');
  }

  static create(item) {
    return apiFetch(_baseEndPoint, 'POST', item);
  }

  update() {
    return apiFetch(`${_baseEndPoint}/${this.id}`, 'PUT', this);
  }

  delete() {
    return apiFetch(`${_baseEndPoint}/${this.id}`, 'DELETE', this);
  }
}
